/*
 * @Descripttion: 微信api模块
 * @Author: xutao
 * @Date: 2020-08-25 09:36:28
 * @LastEditors: kuanggf
 * @LastEditTime: 2021-12-13 09:57:10
 * @FilePath: \yunjiactivity-h5\src\common\utils\wxUtil.js
 */
import wxConstData from '../define/wxConstData.js';
import { getAndroidOSVersion, getAppleOSVersion, getWXVersion, isTestEnv, versionCompare } from "./commonUtil.js";
const tabPageUrlReg = /index\/index|category-nav\/category-nav|cart\/cart|wo\/wo/;
/**
 * 跳转页面(非tab页面)
 * @param {*} param 
 */
export function navigateTo(param) {
    if (!wx || !wx.miniProgram || !wx.miniProgram.navigateTo) {
        console.error('@xts->wxUtil.js navigateTo 无法调用小程序api')
        return
    }
    wx.miniProgram.navigateTo(param)
}

/**
 * 跳转页面(非tab页面)
 * @param {*} param 
 */
 export function redirectTo(param) {
  if (!wx || !wx.miniProgram || !wx.miniProgram.redirectTo) {
      console.error('@xts->wxUtil.js navigateTo 无法调用小程序api')
      return
  }
  wx.miniProgram.redirectTo(param)
}
/**
 * 跳转页面(tab页面)
 * @param {*} param 
 */
export function switchTab(param) {
    if (!wx || !wx.miniProgram || !wx.miniProgram.switchTab) {
        console.error('@xts->wxUtil.js switchTab 无法调用小程序api')
        return
    }
    wx.miniProgram.switchTab(param)
}

/**
 * 跳转页面，兼容tab页和非tab页面
 * @param {Object} param 
 */
export function forwardTo(param){
    let url = param && param.url
    if(tabPageUrlReg.test(url)){
      switchTab(param)
    } else {
      navigateTo(param)
    }
}

/**
 * 小程序跳转按钮：<wx-open-launch-weapp> 版本要求判断
 * 微信版本要求为：7.0.12及以上。 系统版本要求为：iOS 10.3及以上、Android 5.0及以上
 */
export function wxOpenLaunchWeappTagIsValid() {
    return (versionCompare(getAppleOSVersion(), '10.3') > -1 || versionCompare(getAndroidOSVersion(), '5.0') > -1) && versionCompare(getWXVersion(), '7.0.12') > -1
}

/**
  * 获取微信小程序原始id
  */
export function getWxAppOriginId() {
    return isTestEnv() ? wxConstData.yunjiSpeWXAppOriginId : wxConstData.yunjiWXAppOriginId;
}

export default {
    navigateTo,
    forwardTo,
    switchTab,
    redirectTo
}